// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"140":"61e2c5fa","249":"4967900b","395":"25172253","429":"932c8f07","489":"8e45e47a","634":"28de32aa"}[chunkId] + ".chunk.css";
};